import Globals from "../../api";
import { LazyLoadImage } from "react-lazy-load-image-component";
import React from "react";
import ROS_Middle_Center_336_280 from '../ad-units/ros_middle_center_728_90';
import Ros_bottom_center_728_90 from '../ad-units/Ros_bottom_center_728_90';
import ROS_Top_Center_728_90 from '../ad-units/Ros_top_center_728_90';
import "./categorylisting.scss";
import { Suspense, lazy } from "react";
import ImageConvertionDefault from "../../config";
import Rightbar from "../../components/Rightbar/Rightbar";
export default class CategoryListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadUrlData: [],
      page: 1
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.trackScrolling); 
  }

  trackScrolling = () => {
   // console.log("scrlling");
    const wrappedElement = document.getElementById("listDiv");
    if (this.isBottom(wrappedElement)) {
      let newPage = this.state.page;
      newPage++;
      this.setState({
        page: newPage,
      });
     // console.log("next",newPage)
      this.nextPageData(newPage);
      window.removeEventListener("scroll", this.trackScrolling);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.trackScrolling);
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }
  nextPageData(page) {
    let url = window.location.pathname;
    const categoryListURL = Globals.language_based_api + url + "/" + page;
    fetch(categoryListURL)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          categoryData: [...this.props.categoryData, ...data.Contents],
          loadUrlData: data.Contents[3].PageUrl,
          nextPage: true,
        });
        this.props.handler( this.state.categoryData);
        if (this.state.loadUrlData) {
          window.location.url = this.state.loadUrlData;
          window.addEventListener("scroll", this.trackScrolling);
        }
      });
  }
  convertToArr = (arr) => {
    var output = [];
    arr.forEach((value) => {
      if (Array.isArray(value)) {
        output = [...output, ...this.convertToArr(value)];
      } else {
        output.push(value);
      }
    });
    return output;
  };

  render() {
   //console.log("rightbar",this.state.rightbardata);
    const renderLoader = () => <p>Loading</p>;
    let url = window.location.pathname;
    let categoryList = this.props.categoryData;
    /** For Sub Menu Data */
    let navData = this.props.navigationMenu;
    let rawMenu = navData.filter((x) => x.DefaultUrl == url);
    let rawSubMenu = rawMenu.map((item) => (item.Items));

    let subMenuArray = this.convertToArr(rawSubMenu);
    let subMenuItems = subMenuArray.map((item, i) => (
      <li>
        <a href={item.DefaultUrl}>
        {item.Text}
        </a>
      </li>
    ));

    let ArticleList = categoryList.filter((x) => x.Type == "ArticleList");
    let pagelistData = categoryList.filter(
      (x) => x.Type == "PageList" || x.ViewAllUrl == url
    );
    let dataArray = [];
    if (pagelistData.length != 0) {
      pagelistData.forEach((element) => {
        dataArray.push(element.Pages);
      });
    } else {
      ArticleList.forEach((element) => {
        dataArray.push(element.Items);
      });
    }

    let categoryArray = this.convertToArr(dataArray);
    var topContent = categoryArray.slice(0, 3);
    var listContent = categoryArray.slice(3);

    let topListData = topContent.map((item, i) => (
      <li>
        <a href={item.Url}>
          <LazyLoadImage
            effect="blur"
            src={ImageConvertionDefault(item.Thumbnail || item.Image)}
            />
            <h2><span>{item.Title}</span></h2>
        </a>
      </li>
    ));
    let listData = listContent.map((item, i) =>   
    (
      <> {(() => {
        i =   i-1;
                if (i % 9 === 2) {
                  return (
              <div className="ads_between_list"  >
              <Suspense fallback={renderLoader()}>
              <ROS_Middle_Center_336_280 AdData= {this.props.AdData} />
              </Suspense>
               </div>
                  )
                 
                }  else if (i % 15 == 2) {
                  return (
                <div className="ads_between_list" > 
               <Suspense fallback={renderLoader()}>
               <Ros_bottom_center_728_90 AdData= {this.props.AdData}/>
               </Suspense>
                    </div>
                  )
                 
                }
                
              })()}
          <div className="listing_block" id={i}>
        <div className="l_thumb_col">
          <a href={item.Url}>
            <LazyLoadImage
              effect="blur"
              src={ImageConvertionDefault(item.Thumbnail || item.Image)}
            />
          </a>
        </div>
        <div className="l_info_col">
          <h2>
            <a href={item.Url}>{item.Title}</a>
          </h2>
          <div className="l_arti_cont">
            {item.Description}
          </div>
        </div>
      </div>
      </>
      
    ));
   // console.log("/news",this.props.Rightbar)
    return (
      <div>
        <div className="submenu_wrap">
          <div className="container">
            <ul className="cat_sub_menu">{subMenuItems}</ul>
          </div>
        </div>
        <div className="full_ads_block">
                 <Suspense fallback={renderLoader()}>
               <ROS_Top_Center_728_90 AdData= {this.props.AdData} />
             </Suspense>

             {/* {(() => {
                if (url == "/sports-news" ) {
                  return (
                   <>
             <div class ="d_sponsored" >Powered by -
            <a href="https://www.purewin.com/en-IN/betting/cricket" target="_blank"> 
            <img className="mr-4" src={require("../../assets/img/sponser/PureWin 300x100.jpg").default}  alt=" PureWin Cricket Betting" style={{width:"120px",height:"70px"}}/></a>
            
            <a href="https://www.sevenjackpots.com/casino/" target="_blank"> 
              <img src={require("../../assets/img/sponser/7 Jackpots 300x100.jpg").default}  alt="Sevenjackpots Online Casino" style={{width:"136px",height:"54px"}}/></a>
              
             </div>
            
                   </>
                  )
                } 
            //     if(url == "/bollywood"){
            //       return (
            //         <>
            //   <div class ="d_sponsored" >
            //  Sponsored by -
            //  <a href="https://www.sevenjackpots.com/" target="_blank"> 
            //  <img src={require("../../assets/img/sponser/7 Jackpots 300x100.jpg").default}  alt="SevenJackpots India" style={{width:"136px",height:"54px"}}/></a>
            //   </div>
            //         </>
            //        )
            //     }
              })()} */}


             
             </div>
        <div className="container padding15">
          <div className="row">
            <div className="col" id="listDiv">
              <div className="aritcle_container">
                <div className="listing_top_sect">
                  <ul>{topListData}</ul>
                </div>
                {/* <div className="listing_block"> */}
                <div className="cat_listing_wrap">
                {listData}
                </div>
              </div>
            </div>
            <div className="col right_side_bar">
            <Rightbar Rightbar={this.props.Rightbar} googleAds = {this.props.AdData} CricketData = {this.props.CricketData}/>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
